export { useOffersPageMarketingTiles } from './use-offers-page-marketing-tiles';
